/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MediaDefs from "./media/defs.defs.js";
import * as RichtextVideoFacet from "./richtext/videoFacet.defs.js";
import * as MetadataContentWarnings from "./metadata/contentWarnings.defs.js";
import * as MetadataContentRights from "./metadata/contentRights.defs.js";
import * as StreamDefs from "./defs.defs.js";
import * as RepoStrongRef from "../../com/atproto/repo/strongRef.defs.js";

const $nsid = "place.stream.video";

export { $nsid };

/** Some audiovisual content. */
type Main = { $type: "place.stream.video";

  /**
   * Title of the video referenced by this record
   */
  "title":string;

  /**
   * Timestamp when this video record was created. Populated server-side at publication time by place.stream.media.publishVideo.
   */
  "createdAt":l.DatetimeString;

  /**
   * What is the source of this video?
   */
  "source":l.$Typed<MediaDefs.SourceTracks> | l.$Typed<MediaDefs.SourceClip> | l.Unknown$TypedObject;

  /**
   * Description of this video
   */
  "description"?:string;

  /**
   * Duration of the video in milliseconds
   */
  "durationMs":number;

  /**
   * Annotations of text (mentions, URLs, etc)
   */
  "descriptionFacets"?:(RichtextVideoFacet.Main)[];

  /**
   * Thumbnail image for the video.
   */
  "thumb"?:l.BlobRef;

  /**
   * Free-form list of atproto records related in some way to this video
   */
  "connections"?:(l.$Typed<Connection> | l.Unknown$TypedObject)[];

  /**
   * content warning data for this VOD
   */
  "contentWarnings"?:MetadataContentWarnings.Main;

  /**
   * copyright and licensing information for this VOD
   */
  "contentRights"?:MetadataContentRights.Main;

  /**
   * The game or activity in the video.
   */
  "activity"?:l.$Typed<StreamDefs.ActivityGame> | l.$Typed<StreamDefs.ActivityLabel> | l.Unknown$TypedObject;

  /**
   * Freeform tags for this stream. Each tag must be alphanumeric (a-z, A-Z, 0-9) plus colon. Tags with colons indicate a specific tag group (e.g. 'lang:en' indicates the stream's primary language).
   */
  "tags"?:(string)[] };

export type { Main };

/** Some audiovisual content. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"title":/*#__PURE__*/ l.string({"maxLength":1400,"maxGraphemes":140}),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"source":/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<MediaDefs.SourceTracks>((() => MediaDefs.sourceTracks) as any),/*#__PURE__*/ l.typedRef<MediaDefs.SourceClip>((() => MediaDefs.sourceClip) as any)], false),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":50000,"maxGraphemes":5000})),"durationMs":/*#__PURE__*/ l.integer(),"descriptionFacets":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RichtextVideoFacet.Main>((() => RichtextVideoFacet.main) as any), )),"thumb":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob({"accept":["image/*"],"maxSize":1000000})),"connections":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<Connection>((() => connection) as any)], false), )),"contentWarnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentWarnings.Main>((() => MetadataContentWarnings.main) as any)),"contentRights":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentRights.Main>((() => MetadataContentRights.main) as any)),"activity":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<StreamDefs.ActivityGame>((() => StreamDefs.activityGame) as any),/*#__PURE__*/ l.typedRef<StreamDefs.ActivityLabel>((() => StreamDefs.activityLabel) as any)], false)),"tags":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64}), {"maxLength":10}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);

type Connection = { $type?: "place.stream.video#connection";"ref"?:RepoStrongRef.Main };

export type { Connection };

const connection = /*#__PURE__*/ l.typedObject<Connection>($nsid, "connection", /*#__PURE__*/ l.object({"ref":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any))}));

export { connection };
